<template>
  <div>
    <Header v-if="!window.frameElement" :window="window" :parameters="'client'" />
    <div :class="window.width < 480 ? 'container-fluid' : 'container'">
      <div class="card div-card">
        <p style="font-size:36px">
          <img
            style="vertical-align:middle;width:36px"
            src="~@/assets/img/public_logo.png"
          />
          sondage
        </p>
        <div style="margin-top:10px;">
          <input
            class="input"
            type="text"
            name="URLPARTICIPANT"
            :placeholder="$t('public.code_participant')"
            v-model="url_participant"
          />
        </div>
        <div style="margin-top:10px;">
          <button
            class="button-client"
            v-bind="{ disabled: !this.url_participant }"
            @click="RepondreSondage()"
          >
            {{ $t("button.connecter") }}
          </button>
        </div>
      </div>
    </div>
    <MyFooter v-if="!window.frameElement" :window="window" />
  </div>
</template>

<script>
import MyFooter from '@/components/layout/MyFooter'
import Header from '@/components/layout/Header'
export default {
  data () {
    return {
      url_participant: '',
      window: {
        width: window.innerWidth
      }
    }
  },
  components: {
    MyFooter,
    Header
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
    },
    RepondreSondage (evt) {
      window.location =
        'p-' +
        this.url_participant.replace(/[^a-zA-Z0-9.-]/g, function (match) {
          return '_' + match[0].charCodeAt(0).toString(16) + '_'
        })
    }
  }
}
</script>
<style scoped>
.div-card {
  margin-top: 5px;
  padding: 20px;
  text-align: center;
}
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  max-width:300px;
  box-shadow: none;
  font-size: 12px;
}
.input::placeholder {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home.vue